import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a40a8b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "file-btns" }
const _hoisted_3 = { class: "inputs" }
const _hoisted_4 = { class: "info-bar" }
const _hoisted_5 = { style: {"flex":"auto"} }
const _hoisted_6 = { style: {"height":"500px","flex":"auto"} }

import { OioModal, OioSpin, OioButton, OioInput } from '@kunlun/vue-ui-antd';
import { computed, ref, watch } from 'vue';
import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons-vue';
import { useFullscreen } from '../../../../hooks/fullscreen';
import { RuntimeModel } from '@kunlun/dependencies';
import { queryStoreList } from './services';
import { bizTypeEnumMap, ariesIssuingMethodEnumMap, warehouseKindEnumMap } from '../../../../constants';
import { TIssuingMethod } from '../../../../hooks';

interface IProps {
  visible: boolean;
  info: any;
  sellerPartnerId: any;
  bizType: any;
  rModel: RuntimeModel;
  ariesIssuingMethodEnum: TIssuingMethod;
  salesOfficeId: string,
  buyerPartnerId:string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StoreTableDialog',
  props: {
    visible: { type: Boolean },
    info: null,
    sellerPartnerId: null,
    bizType: null,
    rModel: null,
    ariesIssuingMethodEnum: null,
    salesOfficeId: null,
    buyerPartnerId: null
  },
  emits: {
  'update:visible': (val) => true
},
  setup(__props: any, { emit: emits }) {

const props = __props as { visible: boolean, info: any, sellerPartnerId: any, bizType: any, rModel: RuntimeModel, ariesIssuingMethodEnum: TIssuingMethod, salesOfficeId: string, buyerPartnerId:string }




const tableRef = ref<any>();
const storeContentRef = ref<HTMLElement | undefined>();
const { isFullscreen, toggleFullscreen } = useFullscreen(storeContentRef);

const searchERPStoreCodeVal = ref('');
const displayTableData = ref<any[]>([]);
const dataSource = ref<any[]>([]);
const tableLoading = ref(false);
const selectRecords = ref<any[]>([]);
const inventoryInfo = ref<any>({});

const checkboxChangeEvent = () => {
  const $table = tableRef.value;
  if ($table) {
    selectRecords.value = $table.getCheckboxRecords();
  }
};

const updateDisplayTableData = () => {
  const oriData = dataSource.value;
  if (!searchERPStoreCodeVal.value.trim()) {
    displayTableData.value = oriData;
  } else {
    displayTableData.value = oriData.filter((item) => {
      const condition2 = searchERPStoreCodeVal.value.trim()
        ? (item.warehouse?.outCode?.includes(searchERPStoreCodeVal.value) || item.warehouse?.name.toLowerCase()?.includes(searchERPStoreCodeVal.value.toLowerCase()))
        : true;

      return condition2;
    });
    checkboxChangeEvent();
  }
};

watch(
  [dataSource, searchERPStoreCodeVal],
  () => {
    updateDisplayTableData();
  },
  {
    immediate: true
  }
);

const initData = async () => {
  try {
    tableLoading.value = true;
    const params = {
      ariesIssuingMethodEnum: props.ariesIssuingMethodEnum,
      sellerPartnerId: props.sellerPartnerId,
      bizType: props.bizType,
      skuId: props.info.skuId,
      salesOfficeId: props.salesOfficeId,
      buyerPartnerId:props.buyerPartnerId
    };
    const res = await queryStoreList(props.rModel, params);
    dataSource.value = res.inventoryList;
    inventoryInfo.value = res;
  } finally {
    tableLoading.value = false;
  }
};

watch(
  () => props.visible,
  (val) => {
    if (val) {
      initData();
    }
  },
  {
    immediate: true
  }
);

return (_ctx: any,_cache: any) => {
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_vxe_table = _resolveComponent("vxe-table")!

  return (_openBlock(), _createBlock(_unref(OioModal), {
    visible: __props.visible,
    title: "查看库存",
    width: "large",
    "onUpdate:visible": _cache[5] || (_cache[5] = (e) => emits('update:visible', e))
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(OioButton), {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (emits('update:visible', false)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("返回")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "store-content",
        ref_key: "storeContentRef",
        ref: storeContentRef
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(OioInput), {
                value: searchERPStoreCodeVal.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchERPStoreCodeVal).value = $event)),
                placeholder: "按ERP库存地点编码搜索",
                style: {"width":"180px"},
                "allow-clear": ""
              }, null, 8, ["value"]),
              _createElementVNode("span", {
                style: {"font-size":"20px","margin-left":"10px","cursor":"pointer"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(toggleFullscreen) && _unref(toggleFullscreen)(...args)))
              }, [
                (!_unref(isFullscreen))
                  ? (_openBlock(), _createBlock(_unref(FullscreenOutlined), { key: 0 }))
                  : (_openBlock(), _createBlock(_unref(FullscreenExitOutlined), { key: 1 }))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, "商品信息：" + _toDisplayString(inventoryInfo.value.orderDetailDesc), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(OioSpin), { loading: tableLoading.value }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_vxe_table, {
                  "header-align": "center",
                  border: "",
                  ref_key: "tableRef",
                  ref: tableRef,
                  height: "auto",
                  "keep-source": "",
                  size: "mini",
                  "column-config": { resizable: true },
                  data: displayTableData.value,
                  "edit-config": { trigger: 'click', mode: 'cell' },
                  "scroll-x": { enabled: false },
                  "scroll-y": { enabled: true, gt: 0, oSize: 20 },
                  "checkbox-config": { checkField: 'isSelected', reserve: true },
                  "row-config": { keyField: 'id' },
                  onCheckboxChange: _cache[2] || (_cache[2] = () => checkboxChangeEvent()),
                  onCheckboxAll: _cache[3] || (_cache[3] = () => checkboxChangeEvent())
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_vxe_column, {
                      type: "checkbox",
                      fixed: "left",
                      width: "50",
                      align: "center"
                    }),
                    _createVNode(_component_vxe_column, {
                      type: "seq",
                      title: "行号",
                      fixed: "left",
                      width: "50"
                    }),
                    _createVNode(_component_vxe_column, {
                      field: "warehouse.code",
                      title: "仓库编码",
                      width: "140"
                    }),
                    _createVNode(_component_vxe_column, {
                      field: "warehouseKind",
                      title: "仓库类型",
                      "min-width": "120"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("span", null, _toDisplayString(_unref(warehouseKindEnumMap)[scope.row.warehouseKind]), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_vxe_column, {
                      field: "warehouse.name",
                      title: "仓库信息",
                      width: "240",
                      "show-overflow": ""
                    }),
                    _createVNode(_component_vxe_column, {
                      field: "availableNum",
                      title: "可用库存",
                      width: "120"
                    }),
                    _createVNode(_component_vxe_column, {
                      field: "totalNum",
                      title: "物理库存",
                      width: "120"
                    }),
                    _createVNode(_component_vxe_column, {
                      field: "blockedNum",
                      title: "锁定库存",
                      width: "120"
                    }),
                    _createVNode(_component_vxe_column, {
                      field: "warehousePriority",
                      title: "优先级",
                      width: "100"
                    }),
                    _createVNode(_component_vxe_column, {
                      field: "bizType",
                      title: "适用业务类型",
                      width: "100"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("span", null, _toDisplayString(_unref(bizTypeEnumMap)[inventoryInfo.value.bizType]), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_vxe_column, {
                      field: "ariesIssuingMethodEnum",
                      title: "适用代发方式",
                      width: "100"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("span", null, _toDisplayString(_unref(ariesIssuingMethodEnumMap)[scope.row.ariesIssuingMethodEnum]), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ], 512)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})